import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { LeadSubscriptionStatusQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const leadSubscriptionStatusQuery = graphql(`
  query leadSubscriptionStatus($token: String!) {
    leadSubscriptionStatus(token: $token) {
      status
    }
  }
`);

export function useGetLeadSubscriptionStatus(
  token: string | null,
  options?: UseQueryOptions<
    LeadSubscriptionStatusQuery,
    unknown,
    LeadSubscriptionStatusQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["leadSubscriptionStatus", token],
    leadSubscriptionStatusQuery,
    [{ token: token ?? "" }],
    {
      ...options,
      enabled: !!token && (options?.enabled ?? true),
    },
  );

  return { ...rest, data: data?.leadSubscriptionStatus };
}
